import Store from './Store';
import PersistentStore from './PersistentStore';
import {ASSET_STORE} from './Constants';
import {initI18n} from '../i18n/I18n';
import Authenticator from '../protocol/Authenticator';
import Authenticator2 from '../auth/Authenticator2';

/**
 * @type {Store}
 */
 
//Store.GLOBAL_STORE = new Store('GLOBAL', getInitialState());
Authenticator.AUTHENTICATOR_INSTANCE = new Authenticator2();
initI18n();
Store.put(ASSET_STORE, new PersistentStore(ASSET_STORE));

if (process.env.NODE_ENV === 'development') {
  window._store = Store.GLOBAL_STORE;
}
